import {all, call, put, takeEvery} from 'redux-saga/effects';
import {stopSubmit} from 'redux-form/immutable';
import {notify} from 'common/notify';

import * as action from '../actions';
import * as dataContext from '../dataProvider/dataContext';

function* sendFormSaga({form, resolve, reject}) {
	try {
		const response = yield call(dataContext.sendReviewForm, form);
		yield put(action.sendReview.success({response}));
		yield put(notify.success('Спасибо за отзыв!'));
		resolve();
	} catch (err) {
		yield put(action.sendReview.failure({errors: err.response.data}));

		if (err.response.data) {
			const errors = err.response.data.reduce((errors, error) => {
				return {...errors, ...{_error: error.message}};
			}, {});
			yield put(stopSubmit('sendReviewForm', errors));
		}
		yield put(notify.error('При отправке отзыва произошла ошибка'));
		reject();
	}
}

export default function* sagas() {
	return yield all([
		takeEvery(action.sendReview.request, sendFormSaga),
	]);
}



// WEBPACK FOOTER //
// ./src/sagas/reviewSaga.js